import React, { useState, useEffect } from 'react'
import { SideMenu } from '../'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Header from '../Header/Header'
import { Layout } from 'antd'
import { allPaths } from '../../utils/constants'

const MenuLayout = ({ component: Component, setLanguage, language, ...props }) => {
    const user = useSelector(state => state?.authReducer?.user)

    const [collapsed, setCollapsed] = useState(false)
    const { Content, Sider } = Layout

    const toggleCollapsed = () => {
        setCollapsed(!collapsed)
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 900) {
                setCollapsed(true)
            } else {
                setCollapsed(false)
            }
        }
        window.addEventListener('resize', handleResize)
        handleResize()
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    if (!user) {
        return <Redirect to={allPaths?.LOGIN} />
    }

    return (
        <Layout>
            <Header setLanguage={setLanguage} language={language} setCollapsed={setCollapsed} />
            <div className={!collapsed ? 'slider-main-div' : 'slider-main-div-2'}>
                <Sider trigger={null} className='slider-inner-div' collapsible collapsed={collapsed} onCollapse={toggleCollapsed}>
                    <div className='demo-logo-vertical' />
                    <SideMenu language={language} collapsed={collapsed} />
                </Sider>
            </div>
            <Layout>
                <Content style={{ marginTop: '58px' }}>
                    <Component setLanguage={setLanguage} language={language} />
                </Content>
                {/* <Footer className='footer-section'>
                    ©{new Date().getFullYear()} Copy Right Reserved
                </Footer> */}
            </Layout>
        </Layout>
    )
}

export { MenuLayout }
